"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4746],{

/***/ 694746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(269396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var _shared_TextInputBase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(945553);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);





var TextInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_shared_TextInputBase__WEBPACK_IMPORTED_MODULE_2__/* .TextInputBase */ .y, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        ref: ref
    }));
});



/***/ }),

/***/ 442831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ InputError; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(320129);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(646523);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);




var textInputTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.textInput */ .T.textInput, InputError = function(param) {
    var errorText = param.errorText;
    return errorText && typeof errorText == "string" ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        testID: "text-input-error-message",
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
            tag: "span",
            typography: textInputTokens.typography.errorText.default,
            color: textInputTokens.color.content.errorMessage.default,
            children: errorText
        })
    }) : null;
};



/***/ }),

/***/ 19018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ InputFrame; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(320129);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(856350);



var textInputTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.textInput */ .T.textInput, InputFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.View, {
    backgroundColor: textInputTokens.color.background.default,
    flexDirection: "row",
    gap: textInputTokens.padding.gap.textAndIcon.default,
    animation: "linear",
    animateOnly: _tamagui_core__WEBPACK_IMPORTED_MODULE_1__.isWeb ? [
        "border-color",
        "border-top-color",
        "border-left-color",
        "border-bottom-color",
        "border-right-color"
    ] : [
        "borderColor",
        "borderTopColor",
        "borderLeftColor",
        "borderBottomColor",
        "borderRightColor"
    ],
    variants: {
        size: function(size) {
            return {
                borderRadius: textInputTokens.cornerRadius[size],
                paddingVertical: textInputTokens.padding.topBottom[size],
                paddingHorizontal: textInputTokens.padding.leftRight[size],
                height: size in textInputTokens.size.height ? textInputTokens.size.height[size] : void 0
            };
        },
        state: function(state) {
            var backgroundColor = (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(state, textInputTokens.color.background.state) ? textInputTokens.color.background.state[state] : textInputTokens.color.background.default, borderColor = state ? textInputTokens.color.border.state[state] : textInputTokens.color.border.default, borderWidth = textInputTokens.borderWidth.default, hoverStyle = state ? {} : {
                borderColor: textInputTokens.color.border.state.hover
            };
            return {
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderWidth: borderWidth,
                hoverStyle: hoverStyle,
                cursor: state === "inactive" ? "default" : "text"
            };
        }
    }
});



/***/ }),

/***/ 403694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ InputLabel; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(320129);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(856350);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(646523);
/* harmony import */ var _shared_InputLabelContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(825689);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);






var textInputTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.textInput */ .T.textInput, InputLabel = function(param) {
    var size = param.size, title = param.title, supportText = param.supportText, id = param.id, required = param.required, state = param.state;
    return (0,_shared_InputLabelContext__WEBPACK_IMPORTED_MODULE_2__/* .useCheckInputLabel */ .B)(title), title ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
        gap: textInputTokens.padding.gap.titleAndSupport.default,
        children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                tag: "label",
                htmlFor: id,
                typography: textInputTokens.typography.fieldTitle[size],
                color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_5__/* .isKeyOfObject */ .E)(state, textInputTokens.color.content.fieldTitle.state) ? textInputTokens.color.content.fieldTitle.state[state] : textInputTokens.color.content.fieldTitle.default,
                children: [
                    title,
                    required ? " *" : ""
                ]
            }),
            !!supportText && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                tag: "span",
                typography: textInputTokens.typography.supportText.default,
                color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_5__/* .isKeyOfObject */ .E)(state, textInputTokens.color.content.supportText.state) ? textInputTokens.color.content.supportText.state[state] : textInputTokens.color.content.supportText.default,
                children: supportText
            })
        ]
    }) : null;
};



/***/ }),

/***/ 945553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ TextInputBase; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(320129);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/react-native-svg/dist/esm/index.js
var esm = __webpack_require__(502888);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/PasswordShow.js






var SvgPasswordShow = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_object_without_properties/* default */.Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,cjs.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_object_spread/* default */.Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* Svg */.ny, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* Path */.y$, {
            fill: "currentColor",
            d: "M12.002 15.577q1.7 0 2.887-1.19t1.188-2.89-1.19-2.886-2.89-1.188-2.886 1.19-1.188 2.89 1.19 2.886 2.89 1.188M12 14.2q-1.125 0-1.912-.787A2.6 2.6 0 0 1 9.3 11.5q0-1.125.787-1.912A2.6 2.6 0 0 1 12 8.8q1.125 0 1.912.787.788.788.788 1.913t-.787 1.912A2.6 2.6 0 0 1 12 14.2m0 4.3q-3.157 0-5.776-1.685a12.6 12.6 0 0 1-4.18-4.432 1.8 1.8 0 0 1-.182-.434 1.75 1.75 0 0 1 .182-1.332 12.6 12.6 0 0 1 4.18-4.432Q8.842 4.5 12 4.5t5.776 1.685a12.6 12.6 0 0 1 4.18 4.432q.125.216.182.434a1.75 1.75 0 0 1-.182 1.332 12.6 12.6 0 0 1-4.18 4.432Q15.158 18.5 12 18.5m0-1.5a9.54 9.54 0 0 0 5.188-1.488A9.77 9.77 0 0 0 20.8 11.5a9.77 9.77 0 0 0-3.613-4.012A9.55 9.55 0 0 0 12 6a9.55 9.55 0 0 0-5.188 1.487A9.77 9.77 0 0 0 3.2 11.5a9.77 9.77 0 0 0 3.612 4.012A9.54 9.54 0 0 0 12 17"
        })
    }));
};
var PasswordShow_default = SvgPasswordShow;


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/PasswordHide.js






var SvgPasswordHide = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_object_without_properties/* default */.Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,cjs.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_object_spread/* default */.Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* Svg */.ny, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* Path */.y$, {
            fill: "currentColor",
            d: "M15.773 12.973 14.65 11.85q.256-1.335-.702-2.277-.957-.943-2.298-.723l-1.123-1.123q.347-.162.716-.233a4 4 0 0 1 .757-.07q1.702 0 2.89 1.187 1.187 1.187 1.187 2.889 0 .388-.066.757a2.7 2.7 0 0 1-.238.716m3.18 3.112L17.85 15.05q.95-.724 1.7-1.613.75-.887 1.25-1.937a9.77 9.77 0 0 0-3.613-4.012A9.55 9.55 0 0 0 12 6q-.725 0-1.412.1-.688.1-1.388.3L8.035 5.235a10.2 10.2 0 0 1 1.945-.556q.99-.18 2.02-.179 3.223 0 5.921 1.675a11.2 11.2 0 0 1 4.15 4.533 1.6 1.6 0 0 1 .19.792q0 .216-.037.409t-.137.383a9.6 9.6 0 0 1-1.333 2.085 11 11 0 0 1-1.8 1.708M12 18.5q-3.158 0-5.788-1.687a12.45 12.45 0 0 1-4.183-4.446 1.4 1.4 0 0 1-.183-.413 1.8 1.8 0 0 1-.057-.454q0-.231.05-.446.05-.216.175-.421.556-1.02 1.263-1.942A9.5 9.5 0 0 1 4.9 7.038L2.642 4.765a.74.74 0 0 1-.204-.53.72.72 0 0 1 .22-.523.72.72 0 0 1 .527-.218q.31 0 .527.218l16.577 16.577q.207.207.22.514a.7.7 0 0 1-.22.54.72.72 0 0 1-.527.217.72.72 0 0 1-.527-.218l-3.52-3.488a9 9 0 0 1-1.818.494q-.934.152-1.897.152M5.954 8.092a9.7 9.7 0 0 0-1.58 1.536A8.8 8.8 0 0 0 3.2 11.5a9.77 9.77 0 0 0 3.613 4.012A9.54 9.54 0 0 0 12 17q.644 0 1.268-.087a8.6 8.6 0 0 0 1.24-.267l-1.266-1.296a2.5 2.5 0 0 1-.606.18 4 4 0 0 1-.636.047q-1.702 0-2.89-1.188-1.187-1.187-1.187-2.889 0-.333.052-.636t.175-.606z"
        })
    }));
};
var PasswordHide_default = SvgPasswordHide;


// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/fontTokens.js
var fontTokens = __webpack_require__(910533);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/utils.js
var utils = __webpack_require__(856350);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(646523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(302267);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/shared/TrackableContainer.js
var TrackableContainer = __webpack_require__(945822);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/shared/hooks.js
var hooks = __webpack_require__(749555);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/shared/InputError.js
var InputError = __webpack_require__(442831);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/shared/InputFrame.js
var InputFrame = __webpack_require__(19018);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/shared/InputLabel.js
var InputLabel = __webpack_require__(403694);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/createElement/index.js + 5 modules
var createElement = __webpack_require__(618480);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/forwardedProps/index.js
var forwardedProps = __webpack_require__(413250);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/pick/index.js
var pick = __webpack_require__(45819);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/useElementLayout/index.js
var useElementLayout = __webpack_require__(130042);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/useLayoutEffect/index.js
var useLayoutEffect = __webpack_require__(39863);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/useMergeRefs/index.js
var useMergeRefs = __webpack_require__(716528);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/usePlatformMethods/index.js + 1 modules
var usePlatformMethods = __webpack_require__(576833);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/useResponderEvents/index.js + 6 modules
var useResponderEvents = __webpack_require__(872359);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/useLocale/index.js + 1 modules
var useLocale = __webpack_require__(972931);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/index.js + 9 modules
var StyleSheet = __webpack_require__(465620);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/TextInputState/index.js
var TextInputState = __webpack_require__(903177);
;// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/TextInput/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use client';













//import { warnOnce } from '../../modules/warnOnce';

/**
 * Determines whether a 'selection' prop differs from a node's existing
 * selection state.
 */
var isSelectionStale = (node, selection) => {
  var selectionEnd = node.selectionEnd,
    selectionStart = node.selectionStart;
  var start = selection.start,
    end = selection.end;
  return start !== selectionStart || end !== selectionEnd;
};

/**
 * Certain input types do no support 'selectSelectionRange' and will throw an
 * error.
 */
var setSelection = (node, selection) => {
  if (isSelectionStale(node, selection)) {
    var start = selection.start,
      end = selection.end;
    try {
      node.setSelectionRange(start, end || start);
    } catch (e) {}
  }
};
var forwardPropsList = Object.assign({}, forwardedProps/* defaultProps */.lG, forwardedProps/* accessibilityProps */.LO, forwardedProps/* clickProps */._T, forwardedProps/* focusProps */.YB, forwardedProps/* keyboardProps */.Uy, forwardedProps/* mouseProps */.hJ, forwardedProps/* touchProps */.E5, forwardedProps/* styleProps */.vr, {
  autoCapitalize: true,
  autoComplete: true,
  autoCorrect: true,
  autoFocus: true,
  defaultValue: true,
  disabled: true,
  lang: true,
  maxLength: true,
  onChange: true,
  onScroll: true,
  placeholder: true,
  pointerEvents: true,
  readOnly: true,
  rows: true,
  spellCheck: true,
  value: true,
  type: true
});
var pickProps = props => (0,pick/* default */.Z)(props, forwardPropsList);

// If an Input Method Editor is processing key input, the 'keyCode' is 229.
// https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
function isEventComposing(nativeEvent) {
  return nativeEvent.isComposing || nativeEvent.keyCode === 229;
}
var focusTimeout = null;
var TextInput = /*#__PURE__*/react.forwardRef((props, forwardedRef) => {
  var _props$autoCapitalize = props.autoCapitalize,
    autoCapitalize = _props$autoCapitalize === void 0 ? 'sentences' : _props$autoCapitalize,
    autoComplete = props.autoComplete,
    autoCompleteType = props.autoCompleteType,
    _props$autoCorrect = props.autoCorrect,
    autoCorrect = _props$autoCorrect === void 0 ? true : _props$autoCorrect,
    blurOnSubmit = props.blurOnSubmit,
    caretHidden = props.caretHidden,
    clearTextOnFocus = props.clearTextOnFocus,
    dir = props.dir,
    editable = props.editable,
    enterKeyHint = props.enterKeyHint,
    inputMode = props.inputMode,
    keyboardType = props.keyboardType,
    _props$multiline = props.multiline,
    multiline = _props$multiline === void 0 ? false : _props$multiline,
    numberOfLines = props.numberOfLines,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onChangeText = props.onChangeText,
    onContentSizeChange = props.onContentSizeChange,
    onFocus = props.onFocus,
    onKeyPress = props.onKeyPress,
    onLayout = props.onLayout,
    onMoveShouldSetResponder = props.onMoveShouldSetResponder,
    onMoveShouldSetResponderCapture = props.onMoveShouldSetResponderCapture,
    onResponderEnd = props.onResponderEnd,
    onResponderGrant = props.onResponderGrant,
    onResponderMove = props.onResponderMove,
    onResponderReject = props.onResponderReject,
    onResponderRelease = props.onResponderRelease,
    onResponderStart = props.onResponderStart,
    onResponderTerminate = props.onResponderTerminate,
    onResponderTerminationRequest = props.onResponderTerminationRequest,
    onScrollShouldSetResponder = props.onScrollShouldSetResponder,
    onScrollShouldSetResponderCapture = props.onScrollShouldSetResponderCapture,
    onSelectionChange = props.onSelectionChange,
    onSelectionChangeShouldSetResponder = props.onSelectionChangeShouldSetResponder,
    onSelectionChangeShouldSetResponderCapture = props.onSelectionChangeShouldSetResponderCapture,
    onStartShouldSetResponder = props.onStartShouldSetResponder,
    onStartShouldSetResponderCapture = props.onStartShouldSetResponderCapture,
    onSubmitEditing = props.onSubmitEditing,
    placeholderTextColor = props.placeholderTextColor,
    _props$readOnly = props.readOnly,
    readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
    returnKeyType = props.returnKeyType,
    rows = props.rows,
    _props$secureTextEntr = props.secureTextEntry,
    secureTextEntry = _props$secureTextEntr === void 0 ? false : _props$secureTextEntr,
    selection = props.selection,
    selectTextOnFocus = props.selectTextOnFocus,
    showSoftInputOnFocus = props.showSoftInputOnFocus,
    spellCheck = props.spellCheck;
  var type;
  var _inputMode;
  if (inputMode != null) {
    _inputMode = inputMode;
    if (inputMode === 'email') {
      type = 'email';
    } else if (inputMode === 'tel') {
      type = 'tel';
    } else if (inputMode === 'search') {
      type = 'search';
    } else if (inputMode === 'url') {
      type = 'url';
    } else {
      type = 'text';
    }
  } else if (keyboardType != null) {
    // warnOnce('keyboardType', 'keyboardType is deprecated. Use inputMode.');
    switch (keyboardType) {
      case 'email-address':
        type = 'email';
        break;
      case 'number-pad':
      case 'numeric':
        _inputMode = 'numeric';
        break;
      case 'decimal-pad':
        _inputMode = 'decimal';
        break;
      case 'phone-pad':
        type = 'tel';
        break;
      case 'search':
      case 'web-search':
        type = 'search';
        break;
      case 'url':
        type = 'url';
        break;
      default:
        type = 'text';
    }
  }
  if (secureTextEntry) {
    type = 'password';
  }
  var dimensions = react.useRef({
    height: null,
    width: null
  });
  var hostRef = react.useRef(null);
  var prevSelection = react.useRef(null);
  var prevSecureTextEntry = react.useRef(false);
  react.useEffect(() => {
    if (hostRef.current && prevSelection.current) {
      setSelection(hostRef.current, prevSelection.current);
    }
    prevSecureTextEntry.current = secureTextEntry;
  }, [secureTextEntry]);
  var handleContentSizeChange = react.useCallback(hostNode => {
    if (multiline && onContentSizeChange && hostNode != null) {
      var newHeight = hostNode.scrollHeight;
      var newWidth = hostNode.scrollWidth;
      if (newHeight !== dimensions.current.height || newWidth !== dimensions.current.width) {
        dimensions.current.height = newHeight;
        dimensions.current.width = newWidth;
        onContentSizeChange({
          nativeEvent: {
            contentSize: {
              height: dimensions.current.height,
              width: dimensions.current.width
            }
          }
        });
      }
    }
  }, [multiline, onContentSizeChange]);
  var imperativeRef = react.useMemo(() => hostNode => {
    // TextInput needs to add more methods to the hostNode in addition to those
    // added by `usePlatformMethods`. This is temporarily until an API like
    // `TextInput.clear(hostRef)` is added to React Native.
    if (hostNode != null) {
      hostNode.clear = function () {
        if (hostNode != null) {
          hostNode.value = '';
        }
      };
      hostNode.isFocused = function () {
        return hostNode != null && TextInputState/* default.currentlyFocusedField */.Z.currentlyFocusedField() === hostNode;
      };
      handleContentSizeChange(hostNode);
    }
  }, [handleContentSizeChange]);
  function handleBlur(e) {
    TextInputState/* default._currentlyFocusedNode */.Z._currentlyFocusedNode = null;
    if (onBlur) {
      e.nativeEvent.text = e.target.value;
      onBlur(e);
    }
  }
  function handleChange(e) {
    var hostNode = e.target;
    var text = hostNode.value;
    e.nativeEvent.text = text;
    handleContentSizeChange(hostNode);
    if (onChange) {
      onChange(e);
    }
    if (onChangeText) {
      onChangeText(text);
    }
  }
  function handleFocus(e) {
    var hostNode = e.target;
    if (onFocus) {
      e.nativeEvent.text = hostNode.value;
      onFocus(e);
    }
    if (hostNode != null) {
      TextInputState/* default._currentlyFocusedNode */.Z._currentlyFocusedNode = hostNode;
      if (clearTextOnFocus) {
        hostNode.value = '';
      }
      if (selectTextOnFocus) {
        // Safari requires selection to occur in a setTimeout
        if (focusTimeout != null) {
          clearTimeout(focusTimeout);
        }
        focusTimeout = setTimeout(() => {
          // Check if the input is still focused after the timeout
          // (see #2704)
          if (hostNode != null && document.activeElement === hostNode) {
            hostNode.select();
          }
        }, 0);
      }
    }
  }
  function handleKeyDown(e) {
    var hostNode = e.target;
    // Prevent key events bubbling (see #612)
    e.stopPropagation();
    var blurOnSubmitDefault = !multiline;
    var shouldBlurOnSubmit = blurOnSubmit == null ? blurOnSubmitDefault : blurOnSubmit;
    var nativeEvent = e.nativeEvent;
    var isComposing = isEventComposing(nativeEvent);
    if (onKeyPress) {
      onKeyPress(e);
    }
    if (e.key === 'Enter' && !e.shiftKey &&
    // Do not call submit if composition is occuring.
    !isComposing && !e.isDefaultPrevented()) {
      if ((blurOnSubmit || !multiline) && onSubmitEditing) {
        // prevent "Enter" from inserting a newline or submitting a form
        e.preventDefault();
        nativeEvent.text = e.target.value;
        onSubmitEditing(e);
      }
      if (shouldBlurOnSubmit && hostNode != null) {
        setTimeout(() => hostNode.blur(), 0);
      }
    }
  }
  function handleSelectionChange(e) {
    try {
      var _e$target = e.target,
        selectionStart = _e$target.selectionStart,
        selectionEnd = _e$target.selectionEnd;
      var _selection = {
        start: selectionStart,
        end: selectionEnd
      };
      if (onSelectionChange) {
        e.nativeEvent.selection = _selection;
        e.nativeEvent.text = e.target.value;
        onSelectionChange(e);
      }
      if (prevSecureTextEntry.current === secureTextEntry) {
        prevSelection.current = _selection;
      }
    } catch (e) {}
  }
  (0,useLayoutEffect/* default */.Z)(() => {
    var node = hostRef.current;
    if (node != null && selection != null) {
      setSelection(node, selection);
    }
    if (document.activeElement === node) {
      TextInputState/* default._currentlyFocusedNode */.Z._currentlyFocusedNode = node;
    }
  }, [hostRef, selection]);
  var component = multiline ? 'textarea' : 'input';
  (0,useElementLayout/* default */.Z)(hostRef, onLayout);
  (0,useResponderEvents/* default */.Z)(hostRef, {
    onMoveShouldSetResponder,
    onMoveShouldSetResponderCapture,
    onResponderEnd,
    onResponderGrant,
    onResponderMove,
    onResponderReject,
    onResponderRelease,
    onResponderStart,
    onResponderTerminate,
    onResponderTerminationRequest,
    onScrollShouldSetResponder,
    onScrollShouldSetResponderCapture,
    onSelectionChangeShouldSetResponder,
    onSelectionChangeShouldSetResponderCapture,
    onStartShouldSetResponder,
    onStartShouldSetResponderCapture
  });
  var _useLocaleContext = (0,useLocale/* useLocaleContext */.PE)(),
    contextDirection = _useLocaleContext.direction;
  var supportedProps = pickProps(props);
  supportedProps.autoCapitalize = autoCapitalize;
  supportedProps.autoComplete = autoComplete || autoCompleteType || 'on';
  supportedProps.autoCorrect = autoCorrect ? 'on' : 'off';
  // 'auto' by default allows browsers to infer writing direction
  supportedProps.dir = dir !== undefined ? dir : 'auto';
  /*
  if (returnKeyType != null) {
    warnOnce('returnKeyType', 'returnKeyType is deprecated. Use enterKeyHint.');
  }
  */
  supportedProps.enterKeyHint = enterKeyHint || returnKeyType;
  supportedProps.inputMode = _inputMode;
  supportedProps.onBlur = handleBlur;
  supportedProps.onChange = handleChange;
  supportedProps.onFocus = handleFocus;
  supportedProps.onKeyDown = handleKeyDown;
  supportedProps.onSelect = handleSelectionChange;
  /*
  if (editable != null) {
    warnOnce('editable', 'editable is deprecated. Use readOnly.');
  }
  */
  supportedProps.readOnly = readOnly === true || editable === false;
  /*
  if (numberOfLines != null) {
    warnOnce(
      'numberOfLines',
      'TextInput numberOfLines is deprecated. Use rows.'
    );
  }
  */
  supportedProps.rows = multiline ? rows != null ? rows : numberOfLines : 1;
  supportedProps.spellCheck = spellCheck != null ? spellCheck : autoCorrect;
  supportedProps.style = [{
    '--placeholderTextColor': placeholderTextColor
  }, styles.textinput$raw, styles.placeholder, props.style, caretHidden && styles.caretHidden];
  supportedProps.type = multiline ? undefined : type;
  supportedProps.virtualkeyboardpolicy = showSoftInputOnFocus === false ? 'manual' : 'auto';
  var platformMethodsRef = (0,usePlatformMethods/* default */.Z)(supportedProps);
  var setRef = (0,useMergeRefs/* default */.Z)(hostRef, platformMethodsRef, imperativeRef, forwardedRef);
  supportedProps.ref = setRef;
  var langDirection = props.lang != null ? (0,useLocale/* getLocaleDirection */.w1)(props.lang) : null;
  var componentDirection = props.dir || langDirection;
  var writingDirection = componentDirection || contextDirection;
  var element = (0,createElement/* default */.Z)(component, supportedProps, {
    writingDirection
  });
  return element;
});
TextInput.displayName = 'TextInput';
// $FlowFixMe
TextInput.State = TextInputState/* default */.Z;
var styles = StyleSheet/* default.create */.Z.create({
  textinput$raw: {
    MozAppearance: 'textfield',
    WebkitAppearance: 'none',
    backgroundColor: 'transparent',
    border: '0 solid black',
    borderRadius: 0,
    boxSizing: 'border-box',
    font: '14px System',
    margin: 0,
    padding: 0,
    resize: 'none'
  },
  placeholder: {
    placeholderTextColor: 'var(--placeholderTextColor)'
  },
  caretHidden: {
    caretColor: 'transparent'
  }
});
/* harmony default export */ var exports_TextInput = (TextInput);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/shared/TextInputField.js



var textInputTokens = Components/* tokens.textInput */.T.textInput, TextInputField = (0,cjs.styled)(exports_TextInput, {
    focusable: !0,
    borderWidth: 0,
    outlineStyle: "none",
    fontFamily: "$body",
    placeholderTextColor: textInputTokens.color.content.placeholderText.default,
    backgroundColor: "$transparent",
    // This is a workaround for a style set by primer.css
    // @ts-expect-error - RNTextInput does not have a boxShadow prop
    boxShadow: cjs.isWeb ? "none" : void 0,
    variants: {
        size: function(size) {
            return {
                fontSize: textInputTokens.typography.valueText[size],
                fontWeight: textInputTokens.typography.valueText[size],
                letterSpacing: textInputTokens.typography.valueText[size]
            };
        }
    }
}, {
    isInput: !0,
    accept: {
        placeholderTextColor: "color"
    }
});


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/shared/TextInputBase.js


















var TextInputBase_textInputTokens = Components/* tokens.textInput */.T.textInput, PrefixSuffixText = function(_param) /* @__PURE__ */ {
    var size = _param.size, state = _param.state, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "size",
        "state",
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Text/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        tag: "span",
        typography: TextInputBase_textInputTokens.typography.valueText[size],
        color: (0,utils/* isKeyOfObject */.E)(state, TextInputBase_textInputTokens.color.content.prefixSuffix.state) ? TextInputBase_textInputTokens.color.content.prefixSuffix.state[state] : TextInputBase_textInputTokens.color.content.prefixSuffix.default
    }, props), {
        children: children
    }));
}, TextInputBase = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var title = _param.title, supportText = _param.supportText, id = _param.id, name = _param.name, value = _param.value, prefilledValue = _param.prefilledValue, placeholder = _param.placeholder, errorText = _param.errorText, invalid = _param.invalid, ariaLabel = _param.ariaLabel, ariaLabelledBy = _param.ariaLabelledBy, disabled = _param.disabled, required = _param.required, prefix = _param.prefix, suffix = _param.suffix, multiline = _param.multiline, onFocus = _param.onFocus, onBlur = _param.onBlur, onChangeText = _param.onChangeText, analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, textContentType = _param.textContentType, suggestion = _param.suggestion, onSuggestion = _param.onSuggestion, frameProps = _param.frameProps, children = _param.children, propsIn = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "supportText",
        "id",
        "name",
        "value",
        "prefilledValue",
        "placeholder",
        "errorText",
        "invalid",
        "ariaLabel",
        "ariaLabelledBy",
        "disabled",
        "required",
        "prefix",
        "suffix",
        "multiline",
        "onFocus",
        "onBlur",
        "onChangeText",
        "analyticsName",
        "trackImpression",
        "textContentType",
        "suggestion",
        "onSuggestion",
        "frameProps",
        "children"
    ]);
    var _$ref;
    var _ref = (0,cjs.useProps)(propsIn), _size = _ref.size, size = _size === void 0 ? "medium" : _size, props = (0,_object_without_properties/* default */.Z)(_ref, [
        "size"
    ]), _$ref1 = (0,react.useState)(textContentType === "password"), showPassword = _$ref1[0], setShowPassword = _$ref1[1], inputId = (0,hooks/* useInputId */.U0)(id), elementRef = (0,hooks/* useInputName */.Gd)(name), combinedRefs = (0,cjs.useComposedRefs)(ref, elementRef), _$ref2 = (0,hooks/* useFrameFocus */.N7)(combinedRefs), inputRef = _$ref2.inputRef, handleFramePress = _$ref2.handleFramePress, _$ref3 = (0,hooks/* useInputState */.U1)({
        disabled: disabled,
        errorText: errorText,
        invalid: invalid,
        onBlur: onBlur,
        onFocus: onFocus
    }), state = _$ref3.state, handleFocus = _$ref3.handleFocus, handleBlur = _$ref3.handleBlur, heightProps = (0,react.useMemo)(function() {
        return getInputHeightProps({
            multiline: multiline,
            size: size
        });
    }, [
        multiline,
        size
    ]), _$ref4 = (0,react.useState)((_$ref = value !== null && value !== void 0 ? value : prefilledValue) !== null && _$ref !== void 0 ? _$ref : ""), internalValue = _$ref4[0], setInternalValue = _$ref4[1], handleTextChange = function(text) {
        setInternalValue(text), onChangeText === null || onChangeText === void 0 ? void 0 : onChangeText(text);
    };
    var _$ref5;
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(TrackableContainer/* TrackableContainer */.z, {
        analyticsName: analyticsName,
        trackImpression: trackImpression,
        gap: TextInputBase_textInputTokens.padding.gap.textAndField[size],
        eventName: "inputViewEvent",
        children: [
            !!title && /* @__PURE__ */ (0,jsx_runtime.jsx)(InputLabel/* InputLabel */.A, {
                size: size,
                state: state,
                title: title,
                supportText: supportText,
                id: inputId,
                required: required
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(InputFrame/* InputFrame */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                size: size,
                state: state,
                onPress: handleFramePress
            }, frameProps), {
                flex: multiline ? 0 : 1,
                overflow: multiline ? "hidden" : void 0,
                children: [
                    /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        flex: 1,
                        flexDirection: "row",
                        alignItems: multiline ? "flex-start" : "center",
                        gap: TextInputBase_textInputTokens.padding.gap.prefixValueSuffix.default,
                        children: [
                            !!prefix && typeof prefix == "string" && /* @__PURE__ */ (0,jsx_runtime.jsx)(PrefixSuffixText, {
                                size: size,
                                state: state,
                                children: prefix
                            }),
                            /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                flexShrink: 1,
                                flexGrow: 1,
                                overflow: multiline ? "hidden" : void 0,
                                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(TextInputField, (0,_object_spread/* default */.Z)({
                                    secureTextEntry: showPassword,
                                    size: size,
                                    color: (0,utils/* isKeyOfObject */.E)(state, TextInputBase_textInputTokens.color.content.valueText.state) ? TextInputBase_textInputTokens.color.content.valueText.state[state] : TextInputBase_textInputTokens.color.content.valueText.default,
                                    id: inputId,
                                    value: value,
                                    defaultValue: prefilledValue,
                                    placeholder: placeholder,
                                    disabled: disabled,
                                    editable: !disabled,
                                    onFocus: handleFocus,
                                    onBlur: handleBlur,
                                    onChangeText: handleTextChange,
                                    ref: inputRef,
                                    "aria-invalid": !!errorText || invalid,
                                    "aria-required": required,
                                    "aria-label": ariaLabel,
                                    "aria-labelledby": ariaLabelledBy,
                                    multiline: multiline,
                                    textContentType: textContentType,
                                    scrollEnabled: multiline
                                }, heightProps, props))
                            }),
                            !!suffix && typeof suffix == "string" && /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        opacity: 0,
                                        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(PrefixSuffixText, {
                                            size: size,
                                            state: state,
                                            "aria-hidden": !0,
                                            children: suffix
                                        })
                                    }),
                                    /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                        flexDirection: "row",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        overflow: "hidden",
                                        alignItems: "center",
                                        gap: TextInputBase_textInputTokens.padding.gap.prefixValueSuffix.default,
                                        "aria-hidden": !0,
                                        children: [
                                            !!prefix && typeof prefix == "string" && /* @__PURE__ */ (0,jsx_runtime.jsx)(PrefixSuffixText, {
                                                size: size,
                                                state: state,
                                                "aria-hidden": !0,
                                                children: prefix
                                            }),
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                tag: "span",
                                                typography: TextInputBase_textInputTokens.typography.valueText[size],
                                                numberOfLines: 1,
                                                flexShrink: 1,
                                                opacity: 0,
                                                "aria-hidden": !0,
                                                children: (_$ref5 = value !== null && value !== void 0 ? value : prefilledValue) !== null && _$ref5 !== void 0 ? _$ref5 : internalValue
                                            }),
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(PrefixSuffixText, {
                                                size: size,
                                                state: state,
                                                "aria-hidden": !1,
                                                children: suffix
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    textContentType === "password" && /* @__PURE__ */ (0,jsx_runtime.jsx)(PressableBox/* PressableBox */.K, {
                        "aria-label": "Toggle password visibility",
                        testID: "show-password-toggle",
                        analyticsName: "show-password-toggle",
                        onPress: function() {
                            setShowPassword(!showPassword);
                        },
                        children: showPassword ? /* @__PURE__ */ (0,jsx_runtime.jsx)(PasswordShow_default, {}) : /* @__PURE__ */ (0,jsx_runtime.jsx)(PasswordHide_default, {})
                    }),
                    children
                ]
            })),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(InputError/* InputError */.p, {
                errorText: errorText
            }),
            suggestion ? /* @__PURE__ */ (0,jsx_runtime.jsx)(PressableBox/* PressableBox */.K, {
                "aria-label": "",
                analyticsName: "input-suggestion",
                onPress: onSuggestion,
                testID: "input-suggestion",
                justifyContent: "flex-start",
                children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    tag: "span",
                    mt: "$4x",
                    color: "$contentAccentBrand",
                    cursor: "pointer",
                    typography: TextInputBase_textInputTokens.typography.supportText.default,
                    children: [
                        'Did you mean "',
                        suggestion,
                        '"?'
                    ]
                })
            }) : null
        ]
    });
}), getInputHeightProps = function(param) {
    var multiline = param.multiline, size = param.size;
    var props = {}, lineHeightToken = TextInputBase_textInputTokens.typography.valueText[size];
    if (cjs.isIos && !multiline) {
        var ref;
        var lineHeightTokenVariable = (ref = (0,fontTokens/* getLineHeightTokens */.aT)()) === null || ref === void 0 ? void 0 : ref[lineHeightToken];
        props.height = lineHeightTokenVariable && typeof lineHeightTokenVariable != "number" ? lineHeightTokenVariable === null || lineHeightTokenVariable === void 0 ? void 0 : lineHeightTokenVariable.val : void 0;
    } else props.lineHeight = lineHeightToken;
    if (multiline) {
        var numberOfLines = (0,cjs.getTokenValue)(Components/* tokens.textInput.text.row.multiline.default */.T.textInput.text.row.multiline["default"], "text");
        props.numberOfLines = numberOfLines, props.textAlignVertical = "top", props.lineHeight = lineHeightToken;
    }
    return props;
};



/***/ }),

/***/ 825689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useCheckInputLabel; },
/* harmony export */   "F": function() { return /* binding */ InputLabelContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

var InputLabelContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({}), useCheckInputLabel = function(label) {
    var inputId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(InputLabelContext).inputId;
    if (!inputId && !label) throw new Error("Tried to render an input element without an accessible label. Please check that all input components have a non-empty `title` prop.");
};



/***/ }),

/***/ 910533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pp": function() { return /* binding */ getTypographyCSSVariable; },
/* harmony export */   "Yp": function() { return /* binding */ getTypographyValue; },
/* harmony export */   "Yw": function() { return /* binding */ getFontName; },
/* harmony export */   "aT": function() { return /* binding */ getLineHeightTokens; }
/* harmony export */ });
/* unused harmony exports getFontSizeTokens, getFontTokenKeys, getFontTokens, getFontWeightTokens, getLetterSpacingTokens */
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_0__);

var getFontTokens = function() {
    var fontKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$body";
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getConfig)().fontsParsed[fontKey];
}, getFontSizeTokens = function() {
    var fontKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$body";
    return getFontTokens(fontKey).size;
}, getLineHeightTokens = function() {
    var fontKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$body";
    return getFontTokens(fontKey).lineHeight;
}, getLetterSpacingTokens = function() {
    var fontKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$body";
    return getFontTokens(fontKey).letterSpacing;
}, getFontWeightTokens = function() {
    var fontKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$body";
    return getFontTokens(fontKey).weight;
}, getFontTokenKeys = function() {
    var fontKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$body";
    var fontSizeTokens = getFontSizeTokens(fontKey);
    return Object.keys(fontSizeTokens);
}, getTypographyCSSVariable = function(token, property) {
    var fontKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "$body";
    var ref;
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getVariableVariable)((ref = getFontTokens(fontKey)[property]) === null || ref === void 0 ? void 0 : ref[token]);
}, getFontName = function() {
    var weight = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "400", fontKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "$body", isForWeb = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _tamagui_core__WEBPACK_IMPORTED_MODULE_0__.isWeb;
    var ref, ref1;
    if (isForWeb) {
        var family = getFontTokens(fontKey).family;
        return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getVariableValue)(family);
    }
    var fontFace = (ref = getFontTokens(fontKey).face) === null || ref === void 0 ? void 0 : (ref1 = ref[weight]) === null || ref1 === void 0 ? void 0 : ref1.normal;
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getVariableValue)(fontFace);
}, getTypographyValue = function(token, property) {
    var fontKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "$body";
    var ref;
    var variable = (ref = getFontTokens(fontKey)[property]) === null || ref === void 0 ? void 0 : ref[token];
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getVariableValue)(variable);
};



/***/ })

}]);